import { Platform } from 'react-native';
import { apiUrl, deeplinkDomainSuffix, deeplinkHosts } from 'src/core/utils/AppConfig';
import Constants from 'src/core/utils/Constants';
import { isHostOrSubdomain } from 'src/core/utils/Hosts';

// The copy carries the production hosts; every other environment serves the same site on `<host><suffix>`.
export const environmentWebUrl = (url: string): string => {
	const suffix = deeplinkDomainSuffix();

	if (suffix.length === 0) {
		return url;
	}

	const value = new URL(url);

	if (value.hostname.endsWith(suffix)) {
		return url;
	}

	value.hostname = `${value.hostname}${suffix}`;

	return value.toString();
};

const apiHostname = (): string | null => {
	const url = apiUrl();

	return url ? new URL(url).hostname : null;
};

const isThermenWebsite = (hostname: string): boolean =>
	hostname !== apiHostname() && isHostOrSubdomain(hostname, deeplinkHosts());

const hasCampaign = (value: URL): boolean =>
	[...value.searchParams.keys()].some((key) => key.startsWith(Constants.paramsUtmPrefix));

// A link that already carries a campaign keeps it, so marketing can tag a link in the cms.
export const withAppCampaign = (url: string): string => {
	let value: URL;

	try {
		value = new URL(url);
	} catch {
		return url;
	}

	if (!isThermenWebsite(value.hostname) || hasCampaign(value)) {
		return url;
	}

	value.searchParams.set(Constants.paramsUtmSource, Platform.OS);
	value.searchParams.set(Constants.paramsUtmMedium, Constants.utmMediumApp);

	return value.toString();
};
